import store from '@/store'
import _ from 'lodash'
import chroma from 'chroma-js'
import cssVars from 'css-vars-ponyfill'
import $ from 'jquery'
import vuetify from '@/core/vendor/vuetify-wrap'

const defaultThemeColors = {
  primary: '#00AEEF',
  secondary: '#8C8C8C',
  accent: '#82B1FF',
  error: '#FF5252',
  info: '#3F51B5',
  success: '#4CAF50',
  warning: '#FFC107'
}

function generateThemeColors(colors = {}) {
  const mergedColors = _.merge({}, defaultThemeColors, colors)
  const prefix = '--color'
  const cssVariables = _.reduce(mergedColors, (accumulator, color, name) => {
    const fullName = `${prefix}-${name}`
    const chromaColor = chroma(color)
    accumulator[fullName] = chromaColor.get('rgb')
    accumulator[`${fullName}-light`] = chromaColor.brighten(0.75).get('rgb')
    accumulator[`${fullName}-dark`] = chromaColor.darken(0.75).get('rgb')
    return accumulator
  }, {})
  return { cssVariables, colors: mergedColors }
}

function setCurrentThemeColorsOrDefault(colors) {
  const defer = $.Deferred()
  const themeColors = colors || _.get(store.getters.currentTheme, 'colors', generateThemeColors())
  vuetify.framework.theme.themes.light = themeColors.colors
  cssVars({
    variables: themeColors.cssVariables,
    onFinally(hasChanged, hasNativeSupport, benchmark) {
      defer.resolve()
    }
  })
  return defer.promise(themeColors)
}

function setCurrentThemeOrDefault() {
  const theme = getTheme()
  store.dispatch('setUserTheme', theme)
  return setCurrentThemeColorsOrDefault(theme.colors)
}

function getTheme(unit = store.getters.currentUserCompany) {
  return { colors: getThemeColors(unit), logo: _.get(unit, 'logotype.umbracoFile.src') }
}

function getThemeColors(unit = store.getters.currentUserCompany) {
  if(!unit || !unit.hasTheme) {
    return generateThemeColors()
  }
  const colors = _.mergeWith({}, defaultThemeColors, {
    primary: unit.primaryColor,
    secondary: unit.secondaryColor,
    accent: unit.accentColor,
    error: unit.errorColor,
    info: unit.infoColor,
    success: unit.successColor,
    warning: unit.warningColor
  }, (objValue, srcValue) => {
    return !srcValue ? objValue : undefined
  })
  return generateThemeColors(colors)
}

export { setCurrentThemeColorsOrDefault, setCurrentThemeOrDefault }
